import React from 'react';
import Utils from './Utils';
import styled from 'styled-components';
import { HashRouter, Route, Link, Routes } from 'react-router-dom'

import PageWrapper from './PageWrapper';
import { LowerContainer, LowerContainerBox } from './WelcomeScreen';
import { Nav, NavLink } from './PageWrapper';
import { GridspaceLoadingIcon, MixerlabText, MultiLineText, SessionForm } from './Components';

import { Line } from 'react-chartjs-2';
import { FormField, RowFlexDiv, ColFlexDiv, SessionTextArea, SubmitRow } from './Components'

// Styled components for the table
const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
`;

const Th = styled.th`
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    background-color: #f2f2f2;
`;

const Td = styled.td`
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
`;

const Tr = styled.tr`
    &:hover {
        background-color: #f5f5f5;
    }
`;


function wordToHexColor(word) {

  // Ensure the input is a string
  if (typeof word !== 'string') {
    throw new Error('Input must be a string');
  }
  // Hash to separate closely related words
  let hash = 0;
  if (word.length === 0) return hash;

  for (let i = 0; i < word.length; i++) {
    const char = word.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash &= hash; // Convert to 32-bit integer
  }

  // Use the ASCII sum to generate a hex color (limited to values between 0x000000 and 0xFFFFFF)
  const hexColor = ('000000' + (hash % 0x1000000).toString(16)).slice(-6);

  return `#${hexColor}`;
}

const HomeDisplay = <div>Welcome to the Model Evaluation Dashboard! Please browse our dashboards and submit data requests using the panel above</div>

const EmotionDADashboard = <div>Emotion and DA Dashboard in the works...</div>

const RedactionDashboard = <div>Redaction Dashboard in the works...</div>

class SubmitDataRequests extends React.Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      asrInput: '',
      ttsInput: '',
    };
  }

  componentDidMount(){
  }

  onSubmitTTS(e) {
    let data = new FormData(e.target);
    data.append('model', 'tts')
    data.append('word', this.state.ttsInput)
    this.setState({ submitting: true })
    Utils.apiPost("/dashboards/post_data_request/", data)
      .then((response) => {
        this.setState({
          message: response.data.message,
          submitting: false
        });
      })
    }
  
  onSubmitASR(e) {
    let data = new FormData(e.target);
    data.append('model', 'asr')
    data.append('word', this.state.asrInput)
    this.setState({ submitting: true })
    Utils.apiPost("/dashboards/post_data_request/", data)
      .then((response) => {
        this.setState({
          message: response.data.message,
          submitting: false
        });
      })
    }

  render() {
    return (
      <ColFlexDiv style={{'width': '75%'}}>
        <h2>Data Requests for TTS and ASR</h2>
        <RowFlexDiv>
          <a>
          These will go into a shortlist of terms to include in our next Actor and Dayna sessions.
          Please write the word correctly.
          If it is an urgent data request, talk to Mixerlab admins, or submit it multiple times so it gets counted as such. Don't abuse this please.
          </a>
        </RowFlexDiv>
        <RowFlexDiv style={{'width': '100%'}}>
          <SessionForm key="tts" onSubmit={this.onSubmitTTS.bind(this)}>
              <FormField label="TTS Word/Phrase pronounced poorly">
                <SessionTextArea
                  style={{'height': '25px', 'width': '400px'}}
                  name="tts"
                  placeholder="e.g. collect"
                  onChange={(x) => this.setState({'ttsInput': x.target.value})}
                  value={this.state.ttsInput}
                  ref={this.textInput}
                />
              </FormField>
              {!this.state.submitting &&
                <SubmitRow>
                  <button type="submit" name="save">
                    Submit TTS Request
                  </button>
                </SubmitRow>
              }
              {this.state.submitting && <GridspaceLoadingIcon />}
            </SessionForm>
          </RowFlexDiv>
          <RowFlexDiv style={{'width': '100%'}}>
          <SessionForm key="asr" onSubmit={this.onSubmitASR.bind(this)}>
          <FormField label="ASR Word/Phrase Mistranscribed (write correctly)">
              <SessionTextArea
                style={{'height': '25px', 'width': '400px'}}
                name="asr"
                placeholder="e.g. phoebe"
                onChange={(x) => this.setState({'asrInput': x.target.value})}
                value={this.state.asrInput}
                ref={this.textInput}
              />
            </FormField>
            {!this.state.submitting &&
              <SubmitRow>
                <button type="submit" name="save">
                  Submit ASR Request
                </button>
              </SubmitRow>
            }
            {this.state.submitting && <GridspaceLoadingIcon />}
        </SessionForm>
        </RowFlexDiv>
        <h3 style={{'color': 'blue'}}>{this.state.message}</h3>
      </ColFlexDiv>
    )
  }
}

// ASR DASHBOARD
class ASRDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domains: {},
      datasets: {},
      modes: {},
      tableColumns: ['asrmodel::model_domain', 'confidence_mode', 'asrmodel::version', 'asrmodel::prefix', 'dataset::name', 'wer_percentage', 'hallucination_percentage', 'missing_utterance_percentage'],
      versions: [],
      prodOnly: false,
      evals: undefined,
      asrData: undefined,
      loading: false,
      domainOptions: [],
      datasetOptions: [],
      keyOptions: [],
      modeOptions: [],
      sortByColumn: 0,
      sortAscending: true,
      chartMetric: 'wer_percentage',
      plotAgainst: 'asrmodel::version',
      allowLoadEvals: false
    }
  }

  componentDidMount() {
    Utils.apiGet('/dashboards/get_filter_options/').then((response) => {
      this.setState({
        domainOptions: response.data.domainOptions,
        datasetOptions: response.data.datasetOptions,
        keyOptions: response.data.keyOptions,
        modeOptions: response.data.modeOptions,
      })
    })
  }
  
  getASRModelEvaluations(reload) {
    let selectedDomains = []
    let selectedDatasets = []
    let selectedModes = []
    Object.entries(this.state.domains).map(([key, val]) => {
      if (val) {
        selectedDomains.push( key );
      }
    })
    Object.entries(this.state.datasets).map(([key, val]) => {
      if (val) {
        selectedDatasets.push( key );
      }
    })
    Object.entries(this.state.modes).map(([key, val]) => {
      if (val) {
        selectedModes.push( key );
      }
    })
    this.setState({loading: true})
    let params = {'domains': selectedDomains,
                  'datasets': selectedDatasets,
                  'modes': selectedModes,
                  'table_columns': this.state.tableColumns,
                  'prod_only': this.state.prodOnly,
                  'chartMetric': this.state.chartMetric,
                  'reload': reload,
                  'plot_against': this.state.plotAgainst
                } //'versions': this.state.versions, 'datasets': this.state.datasets
    Utils.apiGet('/dashboards/update_asr_evals/?' + new URLSearchParams(params)).then((response) => {
      this.setState({evals: JSON.parse(response.data.evals)})
      Utils.apiGet('/dashboards/generate_asr_graph/?' + new URLSearchParams(params)).then((response) => {
        this.setState({loading: false, asrData: response.data.asr_data})
      })
    })
  }

  updateChecked(element, stateKey, stateObject) {
    stateObject[element] = !stateObject[element]
    var newState  = {}
    newState[stateKey] = stateObject
    this.setState(newState)
  }

  generateOptionsCheckboxes(options, stateKey, stateArray) {
    let optionInputs = options.map((option) => {
      return (
        <div>
        <input
          type="checkbox"
          id={option}
          checked={stateArray[option]}
          onChange={(x) => this.updateChecked(option, stateKey, stateArray)} />{option}</div>
      )
    })
    return (optionInputs)
  }

  updateSelectedOptions(event) {
    const { name, options } = event.target;
    const selectedOptions = Array.from(options)
      .filter(option => option.selected)
      .map(option => option.value);

    this.setState({ [name]: selectedOptions });
  };

  generateOptionsMultiselect(options, stateKey, stateArray) {

    return (
      <select
        id={stateKey}
        name={stateKey}
        multiple
        value={stateArray}
        size={12}
        onChange={(e) => this.updateSelectedOptions(e)}>
        {options.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  }

  formatDate(dateString) {
    const year = parseInt(dateString.substring(0, 2), 10) + 2000;
    const month = parseInt(dateString.substring(2, 4), 10) - 1;
    const day = parseInt(dateString.substring(4, 6), 10);
    const hours = parseInt(dateString.substring(6, 8), 10);
    const minutes = parseInt(dateString.substring(8, 10), 10);
    const seconds = parseInt(dateString.substring(10, 12), 10);
  
    return new Date(year, month, day, hours, minutes, seconds);
  }

  // Function to handle sorting
  handleSort(columnIndex) {
    const { sortByColumn, sortAscending } = this.state;

    // Toggle the sort direction if clicking the same column
    const newSortAscending = sortByColumn === columnIndex ? !sortAscending : true;

    this.setState({
      sortByColumn: columnIndex,
      sortAscending: newSortAscending,
    });
  };

  renderTableHeader(columns) {
    const { sortByColumn, sortAscending } = this.state;

    return (
      <thead>
        <tr>
          {columns.map((column, index) => (
            <Th key={index} onClick={() => this.handleSort(index)}>
              {column}
              {sortByColumn === index && (
                <span>{sortAscending ? ' ▲' : ' ▼'}</span>
              )}
            </Th>
          ))}
        </tr>
      </thead>
    );
  }

  renderTableBody(data, columns) {
    const { sortByColumn, sortAscending } = this.state;

    // Sorting logic
    const sortedRows = Object.keys(data[columns[0]])
      .sort((a, b) => {
        const valueA = data[columns[sortByColumn]][a];
        const valueB = data[columns[sortByColumn]][b];

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          // Numeric sorting
          return sortAscending ? valueA - valueB : valueB - valueA;
        } else {
          // Alphabetic sorting
          const stringA = String(valueA).toLowerCase();
          const stringB = String(valueB).toLowerCase();

          return sortAscending ? stringA.localeCompare(stringB) : stringB.localeCompare(stringA);
        }
      })
      .map((rowName, rowIndex) => (
        <Tr key={rowIndex}>
          {columns.map((column, colIndex) => {
            console.log(data[column][rowName])
            return (
            <Td key={colIndex}>{data[column][rowName] || ''}</Td>
          )})}
        </Tr>
      ));

    return <tbody>{sortedRows}</tbody>;
  }

  renderTable(data) {
    const columns = Object.keys(data);

    const table = (
      <StyledTable>
        {this.renderTableHeader(columns)}
        {this.renderTableBody(data, columns)}
      </StyledTable>
    );

    return table;
  }

  renderChart() {
    const { asrData } = this.state;

    console.log(asrData)
  
    if (asrData.length === 0) {
      // Data not available yet, you might want to render a loading indicator
      return <div>Please load Data to view the graph</div>;
    }
  
    const datasets = [];
    const allLabels = [];
  
    Object.entries(asrData).forEach(([domain, domainDict]) => {
      Object.entries(domainDict).forEach(([dataset, dataDict]) => {
        const dataVals = [];
        const dataTooltip = [];
        const dataLabels = [];
        const colour = wordToHexColor(domain + dataset);
        
        if (dataset in this.state.datasets) {
          Object.entries(dataDict).forEach(([k, v]) => {
            let x_val = k;
            if (this.state.plotAgainst === 'evaluation_date') {
              x_val = this.formatDate(k); // Convert date string to Date object
            }
            dataLabels.push(x_val)
            allLabels.push(x_val);
            dataVals.push(v[0]);
            dataTooltip.push(v[1]);
          });
  
          datasets.push({
            label: domain + ': ' + dataset,
            data: dataVals.map((value, i) => ({
              x: dataLabels[i],
              y: value,
              label: dataTooltip[i]
            })),
            borderColor: colour,
            fill: false,
          });
        }
      });
    });

    const uniqueLabelsSet = new Set(allLabels); // Convert to a Set to remove duplicates
    const sortedLabels = Array.from(uniqueLabelsSet).sort(); // Convert back to an array and sort

    const xAxes = [{
      type: this.state.plotAgainst === 'evaluation_date' ? 'time' : 'category',
      time: {
        unit: 'month', // Adjust the time unit (second, minute, hour, day, etc.)
        displayFormats: {
          minute: 'YYYY-MM-DD HH:mm', // Format for displaying on the x-axis
        },
      },
      labels: sortedLabels
    }];

    const options = {
      responsive: true,
      legend: {
        position: 'top',
        align: 'start'
      },
      title: {
        display: true,
        text: 'Model Chart',
      },
      scales: {
        yAxes: [{
          position: 'bottom',
          min: 0
        }],
        xAxes: xAxes,
      },
      tooltips: {
        callbacks: {
          title: (tooltipItems, data) => {
            const firstItem = tooltipItems[0];
            if (firstItem) {
              const datasetIndex = firstItem.datasetIndex;
              const index = firstItem.index;
              return data.datasets[datasetIndex].data[index].x;
            }
            return '';
          },
          label: (tooltipItem, data) => {
            const datasetIndex = tooltipItem.datasetIndex;
            const index = tooltipItem.index;
            return data.datasets[datasetIndex].data[index].label;
          }
        }
      }
    };
  
    const metricOptions = ['wer_percentage', 'missing_utterance_percentage', 'cutoff_percentage', 'hallucination_percentage', 'unnecessary_noise_percentage'];
    const xOptions = ['evaluation_date', 'asrmodel::version', 'asrmodel::parameters'];
  
    const metricSelect = (
      <div>
        <label htmlFor="metricSelect">Metric to View</label>
        <select
          id="metricSelect"
          value={this.state.chartMetric}
          onChange={(e) => {
            this.setState({ chartMetric: e.target.value }, () => { this.getASRModelEvaluations(false); });
          }}
        >
          <option value="">Select...</option>
          {metricOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <label htmlFor="plotAgainstSelect">Plot Against</label>
        <select
          id="plotAgainstSelect"
          value={this.state.plotAgainst}
          onChange={(e) => {
            this.setState({ plotAgainst: e.target.value }, () => { this.getASRModelEvaluations(false); });
          }}
        >
          <option value="">Select...</option>
          {xOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  
    return (
      <div>
        {metricSelect}
        <Line
          options={options}
          height={700}
          width={1500}
          data={{ labels: sortedLabels, datasets: datasets }}
          onLoad={(chartInstance) => {
            this.chartInstance = chartInstance;
          }} />
      </div>
    );
  }
  

  render() {
    return (
      <ColFlexDiv>
        <h1>ASR Evaluations</h1>
        <MultiLineText style={{'width': '80%', 'margin': '20px'}}>
          <li>If you want to run an evaluation to appear here, see '/core/gspeech/gspeech/asr_test_matrix.py'.</li>
          <li>Each evaluation json is defined by the dataclasses in this python file. Any evaluation json stored at {"gs://mixer-scriber-storage/model_dashboard/asr_evaluations/\{model_domain\}/\{dataset_name\}/\{evaluation_date\}.json"} will appear here.</li>
          <li>Use 'load evals' to load all GCP evaluation files into a local json, then use 'filter evals' to filter the local files.</li>
          <li>Please specify at least one model_domain, mode and dataset to view evals. Check 'Prod Only' if you only want to see production models.</li>
        </MultiLineText>
        <RowFlexDiv style={{'alignItems': 'start', 'justifyContent': 'space-evenly', 'width':'80%'}}>
          <FormField label="ASR Domain">
          {this.generateOptionsCheckboxes(this.state.domainOptions, 'domains', this.state.domains)}
          </FormField>
          <FormField label="Modes of Operation">
            {this.generateOptionsCheckboxes(this.state.modeOptions, 'modes', this.state.modes)}
          </FormField>
          <FormField label="Datasets to Compare">
            {this.generateOptionsCheckboxes(this.state.datasetOptions, 'datasets', this.state.datasets)}
          </FormField>
          <FormField label="Compare Prod Models Only?">
            <input
            type="checkbox"
            id='prodOnly'
            checked={this.state.prodOnly}
            onChange={(x) => this.setState({'prodOnly': !this.state.prodOnly})} />Prod Only
          </FormField>
          </RowFlexDiv>
        <RowFlexDiv>
          <FormField label="Table Headers to Display">
            {this.generateOptionsMultiselect(this.state.keyOptions, 'tableColumns', this.state.tableColumns)}
          </FormField>
        </RowFlexDiv>
        {this.state.loading && 
                <GridspaceLoadingIcon />
              }
        <RowFlexDiv>
        {!this.state.loading && 
          <div>
            <button style={{'margin': '10px'}} onClick={this.getASRModelEvaluations.bind(this, false)}>Filter Evals</button>
            <button style={{'margin': '10px'}} onClick={() => this.setState({'allowLoadEvals': !this.state.allowLoadEvals})}>Load Evals</button>
            {this.state.allowLoadEvals && 
            <div style={{'color': 'red'}}>
              Confirm you want to reload evaluations from GCP (this will take a while and is only necessary if you have added a new evaluation to the bucket. Use 'filter' for basic filtering)
              <button style={{'margin': '10px'}} onClick={this.getASRModelEvaluations.bind(this, true)}>Yes, Load Evals</button>
            </div>
            }
          </div>
        }
        </RowFlexDiv>
        <RowFlexDiv>
          {this.state.evals && this.renderTable(this.state.evals)}
        </RowFlexDiv>
        {this.state.asrData && this.renderChart()}
      </ColFlexDiv>
    )
  }
}


// TTS Dashboard
class TTSDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modelEvals: [],
      visibleEval: undefined,
      imageNames:[],
      comments: [],
      categoryMetrics:[]
    }
  }

  componentDidMount() {
    Utils.apiGet('/dashboards/update_tts_evals/').then((response) => {
      this.setState({
        modelEvals: response.data.model_evals,
      })
    })
  }
  
  getTTSModelEvaluations(reload) {
    this.setState({loading: true})
    let params = {'reload': reload} //'versions': this.state.versions, 'datasets': this.state.datasets
    Utils.apiGet('/dashboards/update_tts_evals/?' + new URLSearchParams(params)).then((response) => {
      this.setState({modelEvals: response.data.model_evals, loading: false})
    })
  }

  getTTSPlots() {
    Utils.apiGet('/dashboards/generate_tts_plots/?' + new URLSearchParams({'evalname': this.state.visibleEval})).then((response) => {
      this.setState({
        imageNames: response.data.image_names,
        comments: response.data.comments,
        categoryMetrics: response.data.category_metrics
      })
    })
  }

  renderEvals() {
    let images = this.state.imageNames.map((image_fn) => {
      return(
        <ColFlexDiv>
          <strong>{image_fn}</strong>
          <img src={image_fn} alt={image_fn} />
        </ColFlexDiv>
      )
    })

    return (
      <ColFlexDiv>
        <h2>{this.state.visibleEval}</h2>
        <hr/>
        <h2>Category Metrics</h2>
        <MultiLineText>{this.state.categoryMetrics}</MultiLineText>
        <hr/>
        <h2>Comments from MOS Scorers</h2>
        <MultiLineText>{this.state.comments}</MultiLineText>
        <hr/>
        <h2>Plots</h2>
        {images}
      </ColFlexDiv>
    )
  }
  

  render() {
    return (
      <ColFlexDiv>
        <h1>TTS Evaluations</h1>
        <MultiLineText style={{'width': '80%', 'margin': '20px'}}>
          <li>Loads evalutaion files from {"gs://mixer-scriber-storage/model_dashboard/tts_evaluations/\{evaluation_name\}/"}. This folder should contain a 'eval_file.json' containing the source evals, and a 'results_file.json' containing the outputs from the MOS task. See examples for format.</li>
          <li>Use 'load evals' to load all GCP evaluation files, then select the one you want to generate/display the graphs and metrics</li>
        </MultiLineText>
        <RowFlexDiv style={{'alignItems': 'start'}}>
          <FormField label="TTS Evaluation">
          <select
            id="TTSEval"
            value={this.state.visibleEval}
            onChange={(e) => {
              this.setState({ visibleEval: e.target.value }, () => { this.getTTSPlots(); });
            }}
          >
            <option value="">Select...</option>
            {this.state.modelEvals.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          </FormField>
        </RowFlexDiv>
        {this.state.loading && 
                <GridspaceLoadingIcon />
              }
        <RowFlexDiv>
        {!this.state.loading && 
          <div>
            <button style={{'margin': '10px'}} onClick={this.getTTSModelEvaluations.bind(this, true)}>Load New Evals</button>
          </div>
        }
        </RowFlexDiv>
        {this.state.visibleEval && this.renderEvals()}
      </ColFlexDiv>
    )
  }
}


const Tab = () => (
  <Nav style={{'backgroundColor': 'transparent', 'textDecoration': 'none', 'justifyContent': 'space-evenly'}}>
    <Link style={{'paddingRight': '20px'}} to='/data_requests'>Data Requests</Link>
    <Link style={{'paddingRight': '20px'}} to='/asr'>ASR</Link>
    <Link style={{'paddingRight': '20px'}} to='/tts'>TTS</Link>
    <Link style={{'paddingRight': '20px'}} to='/emotion_da'>Emotion and DA</Link>
    <Link style={{'paddingRight': '20px'}} to='/redaction'>Redaction</Link>
  </Nav>
)


const Pane = () => {
  return (
    <Routes>
      <Route path='/' element={HomeDisplay}/>
      <Route path='/data_requests' element={<SubmitDataRequests />}/>
      <Route path='/asr' element={<ASRDashboard />}/>
      <Route path='/tts' element={<TTSDashboard />}/>
      <Route path='/emotion_da' element={EmotionDADashboard}/>
      <Route path='/redaction' element={RedactionDashboard}/>
    </Routes>
  )
}

class ModelDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
  }
  
  render() {
    return (
      <HashRouter hashType="noslash">
        <PageWrapper isAdmin={this.props.isAdmin} noContainer={true}>
          <LowerContainer>
            <Tab />
            <Pane />
          </LowerContainer>
        </PageWrapper>
      </HashRouter>
    );
  }

}

export default ModelDashboard;